import axios from "axios";
import { Get, Post } from "../server";

export function getPaySetting() {
  //Get方法用于向后台发送请求
  return Get("/admin/system/conf");
}

export function setPaySetting(data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: "/admin/system/conf",
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 敏感词列表
export function getSensitive(params: any) {
  //Get方法用于向后台发送请求
  return Get("/admin/system/sensitiveWord/sensitiveWords", params);
}

// 创建敏感词
export function CreateSensitive(params: any) {
  //Get方法用于向后台发送请求
  return Post("/admin/system/sensitiveWord/sensitiveWord", params);
}

// 修改敏感词
export function setSensitive(sensitiveWordId: any, data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/system/sensitiveWord/${sensitiveWordId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 删除敏感词
export function deleteSensitive(data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/system/sensitiveWord/sensitiveWords`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 导出群聊红包信息
export const groupRedEnvelope = (params: any) => {
  return Get(`/admin/bill/groupRedEnvelope/groupRedEnvelopes/excel`, params, {
    responseType: "blob",
  });
};

// 导出私聊红包信息
export const privateRedEnvelope = (params: any) => {
  return Get(
    `/admin/bill/privateRedEnvelope/privateRedEnvelopes/excel`,
    params,
    {
      responseType: "blob",
    }
  );
};

// 导出转账信息
export const transferMoney = (params: any) => {
  return Get(`/admin/bill/transferMoney/transferMoneys/excel`, params, {
    responseType: "blob",
  });
};

// 操作记录
export const operationRecord = (params: any) => {
  return Get(`/admin/operatingRecord/operatingRecords`, params)
}

// 礼品积分
export const getSilverCoinDetails = (params: any) => {
  return Get("/admin/bill/silverCoinDetail/silverCoinDetails", params)
}


// 查看版本管理
export const createVersionConfig = (params: any) => {
  return Post("/admin/system/conf/versionHistory", params)
}


export const versionConfig = (params: any) => {
  return Get("/admin/system/conf/versionHistories", params)
}


export const updateVerSionConfig = (versionId: any, params: any) => {
  return axios({
    url: `/admin/system/conf/versionHistory/${versionId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export const deleteVersionConfig = (versionId: any) => {
  return axios({
    url: `/admin/system/conf/versionHistory/${versionId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 获取世界管理员
export const getWorldChatAdmin = () => {
  return Get("/admin/system/conf/worldChat/admins")
}

// 设置
export const setWorldChatAdmins = (params: any) => {
  return axios({
    url: `/admin/system/conf/worldChat/admin`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 删除
export const deleteWorldChatAdmins = (adminId: any) => {
  return axios({
    url: `/admin/system/conf/worldChat/admin/${adminId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export const goldCharges = (params: any) => {
  return Get(`/admin/charge/goldCharges`, params)
}

export const exportGoldCharges = (params: any) => {
  return Get(`/admin/charge/goldCharges/excel`, params, { responseType: "blob" })
}

export const goldCoinDetails = (params: any) => {
  return Get(`/admin/bill/goldCoinDetail/goldCoinDetails/excel`, params, { responseType: "blob" })
}


export const silverCoinDetails = (params: any) => {
  return Get(`/admin/bill/silverCoinDetail/silverCoinDetails/excel`, params, { responseType: "blob" })
}

export const verifyCodes = (params: any) => {
  return Get(`/admin/verifyCodes`, params)
}

export const appPay = (params:any) => {
  return axios({
    url: `/Cashier/AioCheckOut/V5`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: params,
    baseURL: process.env.REACT_APP_PAY,
  });
}

export const upDateGold = (params:any) => {
  return axios({
    url: `/admin/charge/conf/amountList`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data: params,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}